import React from 'react';
import { Mutation } from 'react-apollo';
import { gql } from 'apollo-boost';

export default ({ data }) => (
    <div className="text-center">
        <Mutation mutation={SET_MONTH}>
            {setMonth => (
                <button
                    className={`btn btn-link text-dark ${data.previous ? '' : 'disabled'}`}
                    onClick={() => data.previous && setMonth({ variables: { month: data.previous } })}>
                    <i className="fas fa-chevron-left" />
                </button>
            )}
        </Mutation>

        {data.name}

        <Mutation mutation={SET_MONTH}>
            {setMonth => (
                <button
                    className={`btn btn-link text-dark ${data.next ? '' : 'disabled'}`}
                    onClick={() => data.next && setMonth({ variables: { month: data.next } })}>
                    <i className="fas fa-chevron-right" />
                </button>
            )}
        </Mutation>
    </div>
);

const SET_MONTH = gql`
    mutation setMonth($month: String!) {
        setProjektstundenWidgetMonth(month: $month) @client
    }
`;
